(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // Plays the hover-preview video on a card-gallery slide as soon as that slide becomes
  // the visible one (aria-hidden="false"), and pauses + rewinds it again once it's hidden.
  // Slides only change visibility via the existing show_second_image_on_hover behaviour
  // (mouse hover only - the theme's own pointer handling already ignores touch), so this
  // naturally only plays on hover and never on mobile taps.
  if (!window.__cardGalleryVideoHoverObserverInit) {
    window.__cardGalleryVideoHoverObserverInit = true;

    const handleSlideVisibilityChange = (slide) => {
      const video = slide.querySelector('.card-gallery__hover-video');
      if (!video) return;

      const isVisible = slide.getAttribute('aria-hidden') === 'false';

      if (isVisible) {
        const playResult = video.play();
        if (playResult && typeof playResult.catch === 'function') {
          playResult.catch(() => {});
        }
      } else if (!video.paused) {
        video.pause();
        video.currentTime = 0;
      }
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName !== 'aria-hidden') continue;
        const slide = mutation.target;
        if (slide.closest && slide.closest('.card-gallery')) {
          handleSlideVisibilityChange(slide);
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true,
    });
  }
  } catch(e) { console.error(e); }
})();

})();
